import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';

export const networkInsertHost = async (body) => {
  const res = await axiosInstance.post('HostOwner/Insert', body);
  return res;
};

export const networkUpdateHost = async (id, data) => {
  const res = await axiosInstance.post(`HostOwner/Update/${id}`, data);
  return res;
};

export const networkRemoveHost = async (id) => {
  const res = await axiosInstance.post(`HostOwner/Remove/${id}`, {});
  return res;
};
